import React, { useState, useEffect } from "react";
import { useStyles } from "../../assets/jss/Layout";
import { CustomCloseIcon } from "../CustomComponents/CustomIcon/CustomIcon";
import clsx from "clsx";
import helpPopUpFile from "../../services/helpPopUpFile";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import { useTranslation } from "react-i18next";

const HelpPopup = ({ currentURL, status, handleOnPopUpClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const handlePopUpClose = () => {
    handleOnPopUpClose();
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  const [data, setData] = useState([]);
  const [url] = useState(currentURL.length === 0 ? "dashboard" : currentURL);

  useEffect(() => {
    setData(helpPopUpFile[url]);
  }, [currentURL]);

  const handlePrevButton = () => {
    if (currentSlide > 0) setCurrentSlide(currentSlide - 1);
  };

  const handleNextButton = () => {
    if (currentSlide < data.length - 1) setCurrentSlide(currentSlide + 1);
  };

  const RawHTML = ({ children, className = "" }) => (
    <div
      className={classes.innerTextContainer}
      dangerouslySetInnerHTML={{ __html: t(children) }}
    />
  );

  const outerBoxClick = (e) => {
    handleOnPopUpClose();
  };

  const innerBoxClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={classes.popUpOuter} onClick={outerBoxClick}>
      <div className={classes.popUpInner} onClick={innerBoxClick}>
        <div className={classes.helpPopUpContainer}>
          {data !== undefined &&
            data.map((content, index) => (
              <>
                <div
                  className={clsx(
                    classes.slide,
                    index === currentSlide
                      ? classes.slideShow
                      : classes.slideHide
                  )}
                >
                  <CustomBox
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    className={classes.popUpHeader}
                  >
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.slideNumber}
                    >
                      {" "}
                      {currentSlide + 1} of {data.length}
                    </CustomTypography>
                    <CustomCloseIcon
                      className={classes.popUpCloseIcon}
                      onClick={handlePopUpClose}
                    />
                  </CustomBox>

                  <div className={classes.textContainer}>
                    <CustomTypography
                      component="h1"
                      variant="h5"
                      className={classes.title}
                    >
                      {t(content.title)}
                    </CustomTypography>
                    <RawHTML className={classes.innerTextContainer}>
                      {content.text}
                    </RawHTML>
                  </div>
                  <CustomBox className={classes.popUpImageContainer}>
                    <img
                      src={content.img}
                      className={classes.popUpImage}
                      alt=""
                    />
                  </CustomBox>
                </div>
              </>
            ))}

          {data !== undefined && data.length > 1 && (
            <div className={classes.helpNavigationButton}>
              <a
                className={clsx(
                  classes.helpPrev,
                  currentSlide === 0 ? classes.disabledButton : null
                )}
                onClick={handlePrevButton}
              >
                {t("PREVIOUS")}
              </a>
              <a
                className={clsx(
                  classes.helpNext,
                  currentSlide === data.length - 1
                    ? classes.disabledButton
                    : null
                )}
                onClick={handleNextButton}
              >
                {t("NEXT")}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpPopup;
